document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('survey-badge-data');
  if (!dataEl) return;

  var latestStart = dataEl.dataset.surveyLatestStart;

  var lastVisited = null;
  try {
    lastVisited = localStorage.getItem('surveys_last_visited');
  } catch (e) {
    return;
  }

  if (!latestStart) return;

  var showBadge = false;
  if (!lastVisited) {
    showBadge = true;
  } else {
    var latestStartMs = new Date(latestStart + 'T00:00:00+09:00').getTime();
    var lastVisitedMs = new Date(lastVisited).getTime();
    showBadge = latestStartMs > lastVisitedMs;
  }

  if (showBadge) {
    var targets = [
      document.getElementById('sp-survey-menu-item'),
      document.getElementById('pc-survey-menu-item')
    ];

    targets.forEach(function (el) {
      if (!el) return;

      el.style.position = 'relative';

      var dot = document.createElement('span');
      dot.style.position = 'absolute';
      dot.style.top = '2px';
      dot.style.left = '14px';
      dot.style.width = '8px';
      dot.style.height = '8px';
      dot.style.borderRadius = '50%';
      dot.style.backgroundColor = '#0BA780';
      el.appendChild(dot);
    });
  }
});
